// #17989 - single source of truth for "master company ids of the selected groups".
// Used by Header (store value) and FirstTest (request payload) so the mapping cannot drift.
export const getMasterCompanyIds = (childrenOfGroup, selectedGroupIds) => (
    (childrenOfGroup || [])
        .filter(item => selectedGroupIds?.includes(item?.id))
        .map(item => item?.master_company_id)
);
